import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mainlayout',
    templateUrl: './mainlayout.component.html',
    standalone: false
})
export class MainlayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
